export const GLOBAL_FILTER_SECTION_ID = 'GLOBAL_FILTER_SECTION';
export const USER_TRIALS_FILTER_SECTION_ID = 'USER_TRIALS_FILTER';
